import { apiAxiosAuth } from 'services/api';
import { CredentialFather } from 'types/ProvidersProps';
import { CredentialChild } from 'types/ProvidersProps';

interface RespGetProvidersSettingsProps {
	isSuccess: boolean;
	data: CredentialFather[];
}

export async function getProvidersSettings(
	handleNotify: any,
	setIsOpenLoad: any,
	setMessage: any
) {
	const resp: RespGetProvidersSettingsProps = { isSuccess: false, data: [] };
	setIsOpenLoad(true);
	setMessage('Carregando informações');

	await apiAxiosAuth
		.get('affiliates?withCredentials=true') // Cache de 5 minutos
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = [];
			handleNotify(
				error?.message || 'Houve algum erro para buscar as configurações',
				'error'
			);
		});

	setIsOpenLoad(false);
	return resp;
}

interface DeleteProviderRespProps {
	isSuccess: boolean;
	data: null | CredentialChild;
}

export async function deleteProvider(credential: CredentialChild) {
	const resp: DeleteProviderRespProps = { isSuccess: false, data: null };

	await apiAxiosAuth
		.patch('credentials', {
			credential: null,
			slug: credential.slug
		})
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;
		})
		.catch(() => {
			resp.isSuccess = false;
			resp.data = null;
		});

	return resp;
}
